 
 
import { Payload } from ".";
import { AppDispatch } from "../../configureStore";
import { AutomationData, AutomationParams } from "../../interface/automation";
import execute from "../http/execute";
import failure from "../http/failure";
import { get, post } from "../http/request";
import success from "../http/success";

 
export type AutomationState = {
    automationData?: AutomationData;
    loading: boolean;
    error?: string;
    pdfUrl?: string;
    page8821Url?: string;
};

const initialState: AutomationState = {
    loading: false,
};

export const RESET_AUTOMATION = 'automation/RESET_AUTOMATION';

export const GET_AUTOMATION_DATA_REQUEST = 'automation/GET_AUTOMATION_DATA_REQUEST';
export const GET_AUTOMATION_DATA_SUCCESS = 'automation/GET_AUTOMATION_DATA_SUCCESS';
export const GET_AUTOMATION_DATA_FAILURE = 'automation/GET_AUTOMATION_DATA_FAILURE';

export const TEST_AUTOMATION_REQUEST = 'automation/TEST_AUTOMATION_REQUEST';
export const TEST_AUTOMATION_SUCCESS = 'automation/TEST_AUTOMATION_SUCCESS';
export const TEST_AUTOMATION_FAILURE = 'automation/TEST_AUTOMATION_FAILURE';

const getUrl = (base64: string): string => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob: Blob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfUrl: string = URL.createObjectURL(blob);
    return pdfUrl;
};

type ActionParams =
    | { type: typeof RESET_AUTOMATION; }
    | { type: typeof GET_AUTOMATION_DATA_REQUEST; }
    | { type: typeof GET_AUTOMATION_DATA_SUCCESS; data: AutomationData; }
    | { type: typeof GET_AUTOMATION_DATA_FAILURE; error: string; };

function reducer(state = initialState, action: ActionParams): typeof initialState {
    switch (action.type) {
        case RESET_AUTOMATION:
            return {
                ...initialState,
            };

        case GET_AUTOMATION_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                error: undefined,
            };

        case GET_AUTOMATION_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                automationData: action.data,
                pdfUrl: getUrl(action.data.pdf),
                page8821Url: action.data.page8821 ? getUrl(action.data.page8821) : undefined,
                error: undefined,
            };

        case GET_AUTOMATION_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        default:
            return state;
    }
}

export const getAutomationData = (payload: Payload<AutomationParams>) => (dispatch: AppDispatch) => {
    dispatch({
        type: GET_AUTOMATION_DATA_REQUEST,
        payload,
    });

    execute(get, '/automation/review', payload.input)
        .then(success(dispatch, GET_AUTOMATION_DATA_SUCCESS, payload))
        .catch(failure(dispatch, GET_AUTOMATION_DATA_FAILURE, payload));
};

export const testAutomation = (payload: Payload<{ extracted: any; message: any }>) => (dispatch: AppDispatch) => {
    dispatch({
        type: TEST_AUTOMATION_REQUEST,
        payload,
    });

    execute(post, '/test-automation', payload.input, {})
        .then(success(dispatch, TEST_AUTOMATION_SUCCESS, payload))
        .catch(failure(dispatch, TEST_AUTOMATION_FAILURE, payload));
};

export default reducer;
